export default function errorRedirect(statusCode: number): void {
  if (process.env.NODE_ENV === 'development') {
    return;
  }
  if (statusCode === 403) {
    window.location.href = "/ErrorPages/NotAuthorised";
  } else if (statusCode === 404) {
    window.location.href = "/ErrorPages/NotFound";
  } else {
    window.location.href = "/ErrorPages/Error";
  }
}
